import { useTranslation } from "react-i18next";
import * as z from "zod";
import { useAddressSchema } from "@hooks/schemas/useAddressSchema";
import { useHouseDetailsSchema } from "@hooks/schemas/useHouseDetailsSchema";

export const useAddHouseSchema = (
  fakeAddressEnabled: boolean,
  validateAddress: boolean,
) => {
  const { t } = useTranslation();

  const shouldValidateAddress =
    (fakeAddressEnabled && validateAddress) || !fakeAddressEnabled;

  const addressSchema = useAddressSchema(
    "municipalityId",
    "settlementId",
    "streetId",
    "house",
    "apartment",
  );

  const houseDetailsSchema = useHouseDetailsSchema(
    "jointBillServiceTypeId",
    "area",
    "heatingTypeId",
  );

  return houseDetailsSchema
    .merge(
      z.object({
        sortOrder: z.optional(z.number()),
        displayName: z.optional(z.string()),
        firstName: z.string({
          required_error: t(
            "addHouseModal.form.fields.firstName.errors.required",
          ),
        }),
        lastName: z.string({
          required_error: t(
            "addHouseModal.form.fields.lastName.errors.required",
          ),
        }),
      }),
    )
    .merge(shouldValidateAddress ? addressSchema : z.object({}));
};
